import { _MiscMessages, ConfigSystemParams, DashboardProfit } from 'src/app/core/consts';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { catchError, combineLatest, debounceTime, distinctUntilChanged, Observable, of, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardService } from 'src/app/core/services/utelize/general/dashboard-service';
import { DashboardStatistic } from 'src/app/core/interfaces/general/dashboard-statistic';
import { DashboardTotal_Previous_Current_PercentDTO_EmptyObject } from 'src/app/core/models/system/dashboard/dashboard-total-previous-current-percent.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { TippyToolTipService } from 'src/app/core/services/utelize/general/tippy-tool-tip-service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-widget-row-sims',
  templateUrl: './widget-row-sims.component.html',
  styleUrls: ['./widget-row-sims.component.scss'],
  providers: [TippyToolTipService]
})

export class WidgetRowSimsComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() allowContainerClose: boolean | undefined;
  @Input() containerTitle     : string  | undefined;
  @Input() marginBottom       : string  | undefined="mb-0";
  @Input() useContainer       : boolean | undefined;
  @Input() showTitleHintText  : boolean | undefined;
  
  @Output() containerClosed: EventEmitter<void>=new EventEmitter<void>();
    
  get maxWidgetsPerRow() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.WidgetRow_MaxWidgetsPerRow_Sims, 4); }

  private _fixedWidget_eSim_HasRun           : boolean=false;
  private _fixedWidget_Sim_HasRun            : boolean=false;
  private _fixedWidget_Sim_Reservation_HasRun: boolean=false;
  private filterCompanyID                    : number | undefined;
  private filterDate                         : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  private statTitleTotalAvailableEsims       : string="Available eSIMs";
  private statTitleTotalAvailablePhysicalSims: string="Available physical SIMs";
  // private statTitleTotalReservedEsims        : string=WidgetTitles.totalReservedEsims;
  private statTitleTotalReservedPhysicalSims : string="Reserved physical SIMs";
  
  private destroy$  =new Subject<void>();
  private selection$=new Subject<{ companyId: number; date: { year: number; month: number; day: number } }>();
  

  public expandContainer : boolean=true;
  public statData!       : Array<DashboardStatistic>;
  public visibleContainer: boolean=true;

  constructor(
    private changeDetectorRef  : ChangeDetectorRef,
    private configSystemService: ConfigSystemService,
    private dashboardService   : DashboardService,
    private exceptionsService  : ExceptionsService,
    private tippyToolTipService: TippyToolTipService
  ) {

  }

  public ngOnInit(): void {
    try {
      this.initSelectionStream();
      
      if (!this.containerTitle || this.containerTitle.trim()=="")
        this.containerTitle=_MiscMessages.TitleNotSet;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      setTimeout(() => {
        this.displayData();
      });
      
      this.tippyToolTipService.setupBootstrapTooltips('[data-bs-toggle="tooltip"]', 'left'); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.destroy$.next();
      this.destroy$.complete();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private displayData() {
    try {
      this.statData=[];

      let statTotalAvailableESIMs: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bi bi-sim",
        iconColour    : "suresim-blue",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined,
        loading       : true,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : this.statTitleTotalAvailableEsims,
        value         : undefined,
      }
                  
      let statTotalAvailableSIMs: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bi bi-sim",
        iconColour    : "suresim-blue",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined,
        loading       : true,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : this.statTitleTotalAvailablePhysicalSims,
        value         : undefined,
      }

      // let statTotalReservedESIMs: DashboardStatistic={
      //   decimalPlaces : 0,
      //   icon          : "bi bi-sim",
      //   link          : "/provisioning/devices-allocated",
      //   linkText      : undefined,
      //   loading       : true,
      //   percentage    : <string><unknown>"",
      //   profit        : "",
      //   profitUpIsGood: true,
      //   showProfit    : false,
      //   showSpinner   : false,
      //   title         : this.statTitleTotalReservedEsims,
      //   value         : undefined,
      // }
  
      let statTotalReservedSIMs: DashboardStatistic={
        decimalPlaces : 0,
        icon          : "bi bi-sim",
        iconColour    : "info",
        link          : "/provisioning/devices-allocated",
        linkText      : undefined, //"View SIMs"
        loading       : true,
        percentage    : <string><unknown>"",
        profit        : "",
        profitUpIsGood: true,
        showProfit    : false,
        showSpinner   : false,
        title         : this.statTitleTotalReservedPhysicalSims,
        value         : undefined,
      }

      this.statData.push(statTotalAvailableESIMs);
      this.statData.push(statTotalAvailableSIMs);
      // this.statData.push(statTotalReservedESIMs);
      this.statData.push(statTotalReservedSIMs);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private initSelectionStream(): void {
    try {
      this.selection$
      .pipe(
        debounceTime(150),
        distinctUntilChanged((a, b) =>
          a.companyId ===b.companyId  &&
          a.date.year ===b.date.year  &&
          a.date.month===b.date.month &&
          a.date.day  ===b.date.day
        ),
        switchMap(selected => {
          const companyId=selected.companyId;
          const year     =selected.date.year;
          const month    =selected.date.month;
          const day      =selected.date.day;
          
          const safeStart=<T>(observable: Observable<T>, fallback: T) =>
            observable.pipe(
              startWith(fallback),//           👈
              catchError(err => {
                this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(err)));
                return of(fallback);
              })
            );

          const safeStartRunOnce=<T>(observable: Observable<T>, fallback: T) =>
            observable.pipe(
              //CRN_20251114 - ❌ no startWith ☝
              catchError(err => {
                this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(err)));
                return of(fallback);
              })
            );

          return combineLatest({
            totalAvailableeSimCount: safeStartRunOnce(this.dashboardService.getTotalAvailableeSimCount(companyId, year, month, day), DashboardTotal_Previous_Current_PercentDTO_EmptyObject()),
            totalAvailableSimCount : safeStartRunOnce(this.dashboardService.getTotalAvailableSimCount (companyId, year, month, day), DashboardTotal_Previous_Current_PercentDTO_EmptyObject()),
            // totalReservedeSimCount : safeStartRunOnce(this.dashboardService.getTotalReservedeSimCount (companyId, year, month, day), DashboardTotal_Previous_Current_PercentDTO_EmptyObject()),
            totalReservedSimCount  : safeStartRunOnce(this.dashboardService.getTotalReservedSimCount  (companyId, year, month, day), DashboardTotal_Previous_Current_PercentDTO_EmptyObject())
          });
          // .pipe(
          //   catchError((error) => {
          //     this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
          //     return EMPTY; //👈 CRN_20251114 - If one fails, nothing is returned
          //   })
          // );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
        this.applyTotalAvailableeSimCount(result.totalAvailableeSimCount);
        this.applyTotalAvailableSimCount (result.totalAvailableSimCount);
        // this.applyTotalReservedeSimCount (result.totalReservedeSimCount);
        this.applyTotalReservedSimCount  (result.totalReservedSimCount);
        this.changeDetectorRef.markForCheck();
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public emitSelection(filterCompanyID: number | undefined, filterDate: OurDate | undefined): void {
    try {
      this.filterCompanyID=filterCompanyID;
      this.filterDate     =filterDate;
      this._fixedWidget_Sim_HasRun=false;
      this._fixedWidget_Sim_Reservation_HasRun=false;
      this._fixedWidget_eSim_HasRun=false;

      const companyId=this.filterCompanyID ?? -1;
      const date     ={
        year : <number>(this.filterDate?.year  ?? 1),
        month: <number>(this.filterDate?.month ?? 1),
        day  : <number>(this.filterDate?.day   ?? 1),
      };
      
      this.selection$.next({ companyId, date });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private applyTotalAvailableeSimCount(data: { percentageChange: number; currentTotal: number }) {
    try {
      if (this._fixedWidget_eSim_HasRun)
        return;
      
      if (!this.statData)
        this.displayData();
      
      this.statData.forEach((stat: DashboardStatistic) => {
        if (stat.title==this.statTitleTotalAvailableEsims) {
          stat.loading   =false,
          stat.percentage=<string><unknown>data.percentageChange,
          stat.profit    =data.percentageChange==0 ? DashboardProfit.Equal : (data.percentageChange<0 ? DashboardProfit.Down : DashboardProfit.Up),
          stat.value     =data.currentTotal;

          stat.iconColour=(Number(data.currentTotal) || 0)>0 ? "success" : "danger";
        }
      });

      this._fixedWidget_eSim_HasRun=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private applyTotalAvailableSimCount(data: { percentageChange: number; currentTotal: number }) {
    try {
      if (this._fixedWidget_Sim_HasRun)
        return;
      
      if (!this.statData)
        this.displayData();
      
      this.statData.forEach((stat: DashboardStatistic) => {
        if (stat.title==this.statTitleTotalAvailablePhysicalSims) {
          stat.loading   =false,
          stat.percentage=<string><unknown>data.percentageChange,
          stat.profit    =data.percentageChange==0 ? DashboardProfit.Equal : (data.percentageChange<0 ? DashboardProfit.Down : DashboardProfit.Up),
          stat.value     =data.currentTotal;

          stat.iconColour=(Number(data.currentTotal) || 0)>0 ? "success" : "danger";
        }
      });

      this._fixedWidget_Sim_HasRun=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  // private applyTotalReservedeSimCount(data: { percentageChange: number; currentTotal: number }) {
  //   try {
  //     if (!this.statData)
  //       this.displayData();
      
  //     this.statData.forEach((stat: DashboardStatistic) => {
  //       if (stat.title==this.statTitleTotalReservedEsims) {
  //         stat.loading   =false,
  //         stat.percentage=<string><unknown>data.percentageChange,
  //         stat.profit    =data.percentageChange==0 ? DashboardProfit.Equal : (data.percentageChange<0 ? DashboardProfit.Down : DashboardProfit.Up),
  //         stat.value     =data.currentTotal
  //       }
  //     });
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  private applyTotalReservedSimCount(data: { percentageChange: number; currentTotal: number }) {
    try {
      if (this._fixedWidget_Sim_Reservation_HasRun)
        return;

      if (!this.statData)
        this.displayData();
      
      this.statData.forEach((stat: DashboardStatistic) => {
        if (stat.title==this.statTitleTotalReservedPhysicalSims) {
          stat.loading   =false,
          stat.percentage=<string><unknown>data.percentageChange,
          stat.profit    =data.percentageChange==0 ? DashboardProfit.Equal : (data.percentageChange<0 ? DashboardProfit.Down : DashboardProfit.Up),
          stat.value     =data.currentTotal
        }
      });

      this._fixedWidget_Sim_Reservation_HasRun=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public toggleContainerExpansion(): void {
    try {
      this.expandContainer=!this.expandContainer;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public collapseContainer(): void {
    try {
      this.expandContainer=false;
      this.changeDetectorRef.markForCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeContainer(): void {
    try {
      this.visibleContainer=false;
      this.containerClosed.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public restoreContainer(): void {
    try {
      this.visibleContainer=true;
      this.changeDetectorRef.markForCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
